module.exports = new __parcel__URL__("Ishi_sprites.04112c55.png").toString();